import gemini from "@/gemini";
import type { geminiEvent } from "@/gemini";
import apolloClient from "@/apollo";
import { getStore } from "@/store";
import router from "@/router";

// For testing, mainly
interface SimpleRoute {
  fullPath: string;
}

/**
 * @param attributes
 */
function formatAppRoutes(attributes: Record<string, any>): geminiEvent {
  return {
    metadata: {
      trigger_location: "async_page_init",
      trigger_origin: "frontend",
      schema_name: "app_routes",
      uuid: gemini.uuid(),
      deployment_stage: gemini.getStage(),
    },
    identity: {
      cookie_id: gemini.geminiCookie(),
    },
    attributes,
    annotations: null,
  };
}

// Get attributes from the current route for app_routes event. We rely on "from" route because
// `referrer` is not automatically updated by vue-router and making that work seems far harder
// than checking from.
/**
 * @param from
 */
function getRouteAttributes(
  from: SimpleRoute | null | undefined
): Record<string, any> {
  const referrer = from?.fullPath || document.referrer;
  return {
    path: window.location.pathname,
    hash_path: gemini.emptyToNull(window.location.hash),
    referrer: gemini.emptyToNull(referrer),
    search: gemini.emptyToNull(window.location.search),
  };
}

/**
 * Executes after route change and sends new route to Gemini via our graphQL ingest mutation.
 * @param _
 * @param from
 */
export function sendGeminiAppRoute(
  _: SimpleRoute,
  from: SimpleRoute | null | undefined
): geminiEvent {
  const attributes = getRouteAttributes(from);
  const routeEvent = formatAppRoutes(attributes);
  // TODO: Use span for reporting success/failure
  gemini.send(routeEvent, apolloClient);
  return routeEvent;
}

/**
 * Store next route in localStorage for later use
 */
export async function storeNewRoute() {
  const store = getStore();
  const loggedIn = store.getters["user/isLoggedIn"];
  if (loggedIn) {
    const fullPath = router.currentRoute.value.fullPath;
    await store.dispatch("session/storeSession", {
      sessionUrl: fullPath,
    });
  }
}
